/**
 * JS mirror of PHP `cms_asset_url()`.
 *
 * @param {string|null|undefined} url
 * @returns {string}
 */
export function normalizeCmsAssetUrl(url) {
    if (url == null) {
        return '';
    }

    let value = String(url).trim();
    if (!value) {
        return '';
    }

    if (value.startsWith('//')) {
        value = `https://${value.slice(2)}`;
    } else if (value.startsWith('http://')) {
        value = `https://${value.slice(7)}`;
    }

    // Lowercase ISO2 in any …/countries/XX.svg path (CMS may send upper or mixed case).
    if (/(?:^|\/)(?:images\/)?countries\/[a-z]{2}\.svg(?:[?#]|$)/i.test(value)) {
        return value.replace(
            /((?:^|\/)(?:images\/)?countries\/)([a-z]{2})(\.svg)/gi,
            (_, prefix, code, ext) => `${prefix}${code.toLowerCase()}${ext}`
        );
    }

    return value;
}
